import { MutationTree } from 'vuex';
import { ILoadResourcesFilter } from '@/content-library/types/load-resources-filter';
import { IResource } from '@/api/resources/types/resource';
import { EContentLibraryMutation } from '@/content-library/store/content-library.constants';
import { IContentLibraryState } from '@/content-library/store/content-library.types';

export const mutations: MutationTree<IContentLibraryState> = {
  [EContentLibraryMutation.SetResources](state: IContentLibraryState, resources: IResource[]) {
    state.resources = resources;
  },
  [EContentLibraryMutation.SetTotalCount](state: IContentLibraryState, totalCount: number) {
    state.totalCount = totalCount;
  },
  [EContentLibraryMutation.SetLoaded](state: IContentLibraryState, loaded: boolean) {
    state.loaded = loaded;
  },
  [EContentLibraryMutation.SetLoading](state: IContentLibraryState, loading: boolean) {
    state.loading = loading;
  },
  [EContentLibraryMutation.SetState](state: IContentLibraryState, newState: IContentLibraryState) {
    state.loading = newState.loading;
    state.loaded = newState.loaded;
    state.resources = newState.resources;
    state.totalCount = newState.totalCount;

    state.payload.limit = newState.payload.limit;
    state.payload.offset = newState.payload.offset;

    state.payload.filter.directory = newState.payload.filter.directory;
    state.payload.filter.searchTerms = newState.payload.filter.searchTerms;
    state.payload.filter.sortBy = newState.payload.filter.sortBy;
    state.payload.filter.sortOrder = newState.payload.filter.sortOrder;
    state.payload.filter.type = newState.payload.filter.type;
  },
  [EContentLibraryMutation.SetPagination](
    state: IContentLibraryState,
    { offset, limit }: { offset: number; limit: number }
  ) {
    state.payload.offset = offset;
    state.payload.limit = limit;
  },
  [EContentLibraryMutation.SetFilter](state: IContentLibraryState, filter: ILoadResourcesFilter) {
    state.payload.filter = filter;
  },
};
